import { FC } from 'react';
import styled from 'styled-components';

type TProps = {
  marketType: string;
  team1: string;
  team2: string;
  name?: string;
};

const Header = styled.div`
  background-color: var(--v3-black-0);
  display: flex;
  flex-direction: row;
  align-items: flex-start;
`;

const MarketName = styled.div`
  flex: 1;
  color: var(--v3-primary-6);
  letter-spacing: 0.42px;
  line-height: 16px;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 12px;
  padding: 4px 2px;
  &:first-child {
    padding-left: 8px;
  }
  &:last-child {
    padding-right: 8px;
  }
`;

export const HeaderComp: FC<TProps> = ({ marketType, team1, team2, name }) => {
  return marketType.toLowerCase().includes('handicap') ? (
    <Header className="market__header">
      <MarketName className="market__name">{team1}</MarketName>
      {!!name && <MarketName>{name}</MarketName>}
      <MarketName className="market__name">{team2}</MarketName>
    </Header>
  ) : null;
};
